export default __webpack_public_path__ + "static/media/bmw.24d8457d.png";